// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1YQeZ","productName":"Table_productName__13Sc6"};